"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default() {}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-shape/src/noop.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-shape/src/noop.js
// module chunks = 1